import React from 'react'
import SvgLinkedin from '../../images/svg/SvgLinkedin'

export default function Linkedin() {
    return(
        <div>
            <a target="_blank" href="https://www.linkedin.com/in/heacosta/">
                <SvgLinkedin />
            </a>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/containers/navigation/Linkedin.jsx